import React, { useState, useCallback, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import {
    StyleSheet,
    Text,
    View,
    Image,
    Dimensions,
    FlatList,
    ActivityIndicator,
} from "react-native-web";

import { connect, useDispatch, useSelector } from "react-redux";
import {
    FomraatedDate,
} from "../../shared/core/datehelper";

import ReminderWebHandler from "../components/ReminderHandler";
import { fetchReminderFromApi, fetchMoreReminderFromApi } from "../../shared/actions/ReminderActions";
import ReminderHandler from "../components/ReminderHandler";
import { appServices } from "../../shared/redux/actions/appServices";
const RemidersHome = props => {

    const [isloaded, setIsload] = React.useState(false);

    // const { Reminders, isGettingReminders } = props.Reminders;
    const { Reminders, isGettingReminders } = useSelector((state)=>state.PatientAlerts)
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(100);
    const dispatch= useDispatch()

    React.useEffect(() => {
        const script = document.createElement("script");
        script.async = true;
        script.src = "https://indici-pre-production.web.app/assets/js/template.js";
        document.body.appendChild(script)
        // d.div.appendChild(script);
    }, [])
const payload={
    PatientID: "",
    PageSize: pageSize,
    PageNumber: pageNumber,
}

    useEffect(() => {
        //alert('Called Future')
        // props.getReminder(pageSize, pageNumber);
        dispatch(appServices.PatientAlerts(payload))
    }, [])

    return (
        <div>
            <Header />
            <div id="myphonemenu" className="page-body">
                <Sidebar />
                <div className="page-content-wrapper">
                    <div className="page-content-wrapper-inner">
                        <div className="viewport-header">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb has-arrow">
                                    <li className="breadcrumb-item">
                                        <a href="#">Dashboard</a>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Reminders</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="content-viewport">
                            <div className="row">
                                <div className="col-12">
                                    <div className="grid">
                                        <div className="grid-body">
                                            <h2 className="grid-title">Reminders</h2>
                                            <div className="item-wrapper">

                                                {
                                                    isGettingReminders && (
                                                        <View style={{ textAlign: "center", marginBottom: 5 }}>
                                                            <ActivityIndicator size="small" color="#00A1DE" />
                                                        </View>
                                                    )
                                                }
                                                {
                                                    Reminders && Reminders.length ? (
                                                        <FlatList
                                                            style={{ marginTop: 15 }}
                                                            data={Reminders}
                                                            renderItem={({ item }) => (
                                                                <ReminderHandler
                                                                    reminderProvider={item.resource.sender.display}
                                                                    reminderNote={item.resource.note == undefined ? "(Not Available)" : item.resource.note.text}
                                                                    reminderDate={FomraatedDate(item.resource.sent)}
                                                                    reminderDescription={item.resource.extension[0].valueString}
                                                                />
                                                            )}
                                                            keyExtractor={(item) => item.resource.id}
                                                            initialNumToRender={10}
                                                            maxToRenderPerBatch={10}
                                                            windowSize={7}

                                                        />
                                                    ) : !isGettingReminders && <View style={{ flex: 1, flexDirection: "column", justifyContent: 'center', alignItems: 'center' }}>
                                                        <Text style={{ marginTop: 10, }}>No Records Found</Text>
                                                    </View>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer className="footer">
                      
                    </footer>
                </div>

            </div>

        </div>
    )
}





// function mapStateToProps(state) {
//     return {
//         Reminders: state.Reminder,
//     };
// }

// function mapDispatchToProps(disptach) {
//     return {
//         getReminder: (pageSize, pageNumber) => disptach(fetchReminderFromApi(pageSize, pageNumber)),
//         //getMoreReminder: (pageNumber, pageSize) => disptach(fetchMoreReminderFromApi(pageNumber, pageSize)),
//     };
// }
// export default connect(mapStateToProps, mapDispatchToProps)(RemidersHome);

export default RemidersHome
